import { render, staticRenderFns } from "./GridBox.vue?vue&type=template&id=59bb6683"
import script from "./GridBox.vue?vue&type=script&lang=ts"
export * from "./GridBox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports